import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './NewsletterSignup.css';

const NewsletterSignup: React.FC = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  // HubSpot Partner ID
  const partnerId = '48197990';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Send tracking event to HubSpot
    if ((window as any)._hsq) {
      (window as any)._hsq.push(['identify', {
        email: email
      }]);
      
      (window as any)._hsq.push(['trackEvent', {
        id: 'newsletter_signup',
        value: partnerId
      }]);
    }
    
    // Simulate submission
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setEmail('');
    }, 800);
  };

  return (
    <div className="newsletter-signup-form gesslar-newsletter-form email-subscription-form newsletter-form">
      <div className="newsletter-content">
        <h3>{t('newsletter.title', 'Stay Up To Date')}</h3>
        <p>{t('newsletter.description', 'Subscribe to our newsletter for the latest updates, landscaping tips, and exclusive offers.')}</p>
        
        {isSubmitted ? (
          <div className="success-message">
            <p>{t('newsletter.success', 'Thank you for subscribing to our newsletter!')}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="email"
                placeholder={t('newsletter.emailPlaceholder', 'Your email address')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button 
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 
                  t('newsletter.submitting', 'Subscribing...') : 
                  t('newsletter.submit', 'Subscribe')}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default NewsletterSignup; 